import React from 'react';
import { useTranslation } from '../hooks/useTranslation';

const About = () => {
  const { t, language } = useTranslation();
  return (
    <section id="about" className="about">
      <div className="container">
        <div className="section-header">
          <h2 className="section-title">{t('about.title')}</h2>
          <p className="section-subtitle">
            {t('about.subtitle')}
          </p>
          <p className="about-description">
            {t('about.description')}
          </p>
        </div>
        
        <div className="about-stats">
          <div className="stat-item">
            <div className="stat-number">100</div>
            <div className="stat-label">{t('about.stats.markets')}</div>
          </div>
          <div className="stat-item">
            <div className="stat-number">10,000</div>
            <div className="stat-label">{t('about.stats.peopleJoin')}</div>
          </div>
          <div className="stat-item">
            <div className="stat-number">10</div>
            <div className="stat-label">{t('about.stats.expertAdvisor')}</div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;